import { cn } from '@plato/ui/util/classes';
import type { PropsWithChildren } from 'react';

type Props = {
    className?: string;
} & PropsWithChildren;

export function DataText({ children, className = '' }: Props) {
    return <span className={cn('tabular-nums', className)}>{children}</span>;
}
